<template>
  <div id="settings-page">
    <SettingsUser class="c-max-w" v-if="this.userType === 'artist'"/>
    <SettingsLabel class="c-max-w" v-else-if="this.userType === 'label'"/>
    <Loader v-else class="pos-center" />

  </div>
</template>

<script>
import SettingsUser from '@/components/settings/SettingsUser.vue'
import SettingsLabel from "@/components/settings/SettingsLabel.vue";
import Loader from "@/components/misc/Loader.vue";
import { mapState } from "vuex";

export default {
  name: 'SettingsPage',
  components: {
    Loader,
    SettingsLabel,
    SettingsUser,
  },
  data() {
    return {};
  },
  metaInfo: {
    title: "Settings",
  },
  mounted() {
      // if (localStorage.getItem('reloaded')) {
      //     // The page was just reloaded. Clear the value from local storage
      //     // so that it will reload the next time this page is visited.
      //     localStorage.removeItem('reloaded');
      // } else {
      //     // Set a flag so that we know not to reload the page twice.
      //     localStorage.setItem('reloaded', '1');
      //     location.reload();
      // }
  },
  computed: {
    ...mapState(["userType"]),
  },
  watch: {
    userType() {},
  },
}
</script>
